<section>
  <div class="container-fluid py-4 px-4">

    <div class="container-fluid container-card mb-4">
      <h1 class="heading-1">Residences Statistics</h1>

      <div class="row">
        <div class="col-12 col-md-12 col-lg-4">
          <div class="card card-property">
            
            <div class="card-header">
                <h5 class="card-title align-items-center card-title-custom">
                    <img src="assets/icons/pie-chart.png"> Sales Revenue
                </h5>
            </div>
            
            <div *ngIf="!isLoading && residence.length > 0" style="padding-left:  15px; padding-right: 15px;">
  
              <!-- TOTAL SECTION (Modified) -->
              <div class="container-fluid container-box-progress" *ngFor="let item of totalRevenueOnly">
                
                <!-- Header dengan master toggle -->
                <div class="row header-row" (click)="toggleTotal()" style="cursor: pointer;">
                  <div class="col-5 title-text">
                    {{ item.property_name }}
                    <i class="fas ms-2" [class.fa-chevron-down]="!isTotalExpanded" [class.fa-chevron-up]="isTotalExpanded"></i>
                  </div>
                  <div class="col-7 total-text">{{ item.sales_revenue| rupiah }}</div>
                </div>
                <!-- As Of Section -->
                <div class="metric-group">
                  <div class="remarks-text">{{ item.tas_remark }}</div>
                  <div class="percentage-value-wrapper">
                    <span class="value-text">{{ item.as_sales_revenue | rupiah }}</span>
                    <span class="percentage-text" [class]="getPercentageClass(item.as_revenue_pctg)">
                      {{ item.as_revenue_pctg }}%
                    </span>
                    <!-- Tooltip hanya muncul jika as_revenue_pctg !== 100 -->
                    <span class="value-text" 
                          *ngIf="item.as_revenue_pctg !== 100"
                          data-bs-toggle="tooltip" 
                          data-bs-placement="top" 
                          title="Estimasi pendapatan maksimal dari total penjualan saat ini dan potensi penjualan sisa stok unit yang tersedia.">
                      {{ item.potential_revenue | rupiah }}
                      <i class="fas fa-info-circle text-muted ms-1" style="font-size: 12px;"></i>
                    </span>
                    
                    <!-- Tanpa tooltip jika as_revenue_pctg === 100 -->
                    <span class="value-text" 
                          *ngIf="item.as_revenue_pctg === 100">
                      {{ item.potential_revenue | rupiah }}
                    </span>
                    
                  </div>
                </div>
                
                
                <!-- Expandable Sections (hanya tampil jika Total di-expand) -->
                <div *ngIf="isTotalExpanded">
                  <!-- last month Section (selalu tampil) -->
                  <div class="metric-group">
                    <div class="remarks-text">{{ item.lm_remark }}</div>
                    <div class="percentage-value-wrapper">
                      <span class="percentage-text" [class]="getPercentageClass(item.lm_revenue_pctg)">
                        {{ item.lm_revenue_pctg }}%
                      </span>
                      <span class="value-text">{{ item.lm_sales_revenue| rupiah }}</span>
                    </div>
                  </div>

                  <!-- Last Year Section -->
                  <div class="metric-group">
                    <div class="remarks-text">{{ item.ly_remark }}</div>
                    <div class="percentage-value-wrapper">
                      <span class="percentage-text" [class]="getPercentageClass(item.ly_revenue_pctg)">
                        {{ item.ly_revenue_pctg }}%
                      </span>
                      <span class="value-text">{{ item.ly_sales_revenue | rupiah }}</span>
                    </div>
                  </div>

                  <!-- This Year Section -->
                  <div class="metric-group">
                    <div class="remarks-text">{{ item.ty_remark }}</div>
                    <div class="percentage-value-wrapper">
                      <span class="value-text">{{ item.ty_sales_revenue | rupiah }}</span>
                      <span class="percentage-text" [class]="getPercentageClass(item.ty_revenue_pctg)">
                       {{ item.ty_revenue_pctg }}%
                      </span>
                      <!-- Tooltip hanya muncul jika ty_revenue_pctg !== 100 -->
                      <span class="value-text" 
                            *ngIf="item.ty_revenue_pctg !== 100"
                            data-bs-toggle="tooltip" 
                            data-bs-placement="top" 
                            title="Estimasi pendapatan maksimal dari total penjualan saat ini dan potensi penjualan sisa stok unit yang tersedia.">
                        {{ item.potential_revenue | rupiah }}
                        <i class="fas fa-info-circle text-muted ms-1" style="font-size: 12px;"></i>
                      </span>
                      
                      <!-- Tanpa tooltip jika ty_revenue_pctg === 100 -->
                      <span class="value-text" 
                            *ngIf="item.ty_revenue_pctg === 100">
                        {{ item.potential_revenue | rupiah }}
                      </span>
                      
                    </div>
                  </div>
                </div>  
              </div>

              <!-- Detail Section (dengan icon) -->
              <div class="mb-3 revenue-item-card" *ngFor="let item of residence; let i = index">
                <div *ngIf="item.property_name !== 'Total'" style="padding-top: 20px;">
                  <div class="row header-row" (click)="toggleExpand(i)" style="cursor: pointer;">
                    <div class="col-5 title-text">
                      {{ item.property_name }}
                      <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[i]" [class.fa-chevron-up]="expandedStates[i]"></i>
                    </div>
                    <div class="col-7 total-text">{{ item.sales_revenue| rupiah }}</div>
                  </div>
                  <div class="metric-group">
                    <div class="remarks-text remarks-with-padding">{{ item.tas_remark }}</div>
                    <div class="percentage-value-wrapper">
                      <span class="value-text">{{ item.as_sales_revenue | rupiah }}</span>
                      <span class="percentage-text" [class]="getPercentageClass(item.as_revenue_pctg)">
                        {{ item.as_revenue_pctg }}%
                      </span>
                      <!-- Tooltip hanya muncul jika as_revenue_pctg !== 100 -->
                      <span class="value-text" 
                            *ngIf="item.as_revenue_pctg !== 100"
                            data-bs-toggle="tooltip" 
                            data-bs-placement="top" 
                            title="Estimasi pendapatan maksimal dari total penjualan saat ini dan potensi penjualan sisa stok unit yang tersedia.">
                        {{ item.potential_revenue | rupiah }}
                        <i class="fas fa-info-circle text-muted ms-1" style="font-size: 12px;"></i>
                      </span>
                      
                      <!-- Tanpa tooltip jika as_revenue_pctg === 100 -->
                      <span class="value-text" 
                            *ngIf="item.as_revenue_pctg === 100">
                        {{ item.potential_revenue | rupiah }}
                      </span>
                      
                    </div>
                  </div>
                  
                  
                  <div *ngIf="expandedStates[i]">
                    <div class="metric-group">
                      <div class="remarks-text remarks-with-padding">{{ item.lm_remark }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(item.lm_revenue_pctg)">
                          {{ item.lm_revenue_pctg }}%
                        </span>
                        <span class="value-text">{{ item.lm_sales_revenue | rupiah }}</span>
                      </div>
                    </div>
                    <div class="metric-group">
                      <div class="remarks-text remarks-with-padding">{{ item.ly_remark }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(item.ly_revenue_pctg)">
                          {{ item.ly_revenue_pctg }}%
                        </span>
                        <span class="value-text">{{ item.ly_sales_revenue | rupiah }}</span>
                      </div>
                    </div>
                    <div class="metric-group  last-group">
                      <div class="remarks-text remarks-with-padding">{{ item.ty_remark }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="value-text">{{ item.ty_sales_revenue | rupiah }}</span>
                        <span class="percentage-text" [class]="getPercentageClass(item.ty_revenue_pctg)">
                          {{ item.ty_revenue_pctg }}%
                        </span>
                        <!-- Tooltip hanya muncul jika ty_revenue_pctg !== 100 -->
                        <span class="value-text" 
                              *ngIf="item.ty_revenue_pctg !== 100"
                              data-bs-toggle="tooltip" 
                              data-bs-placement="top" 
                              title="Estimasi pendapatan maksimal dari total penjualan saat ini dan potensi penjualan sisa stok unit yang tersedia.">
                          {{ item.potential_revenue | rupiah }}
                          <i class="fas fa-info-circle text-muted ms-1" style="font-size: 12px;"></i>
                        </span>
                        
                        <!-- Tanpa tooltip jika ty_revenue_pctg === 100 -->
                        <span class="value-text" 
                              *ngIf="item.ty_revenue_pctg === 100">
                          {{ item.potential_revenue | rupiah }}
                        </span>
                        
                      </div>
                    </div>
                    
                  </div>  
                </div>
              </div>

            </div>
            
          </div>
        </div>

        <div class="col-12 col-md-12 col-lg-4">
          <div class="card card-property">
            
            <div class="card-header">
                <h5 class="card-title align-items-center card-title-custom">
                    <img src="assets/icons/pie-chart.png"> Sales Unit
                </h5>
            </div>
            
            <div *ngIf="!isLoading && residence.length > 0" style="padding-left:  15px; padding-right: 15px;">
  
              <!-- TOTAL SECTION (Modified) -->
              <div class="container-fluid container-box-progress" *ngFor="let item of totalRevenueOnly">
                
                <!-- Header dengan master toggle -->
                <div class="row header-row" (click)="toggleTotal()" style="cursor: pointer;">
                  <div class="col-5 title-text">
                    {{ item.property_name }}
                    <i class="fas ms-2" [class.fa-chevron-down]="!isTotalExpanded" [class.fa-chevron-up]="isTotalExpanded"></i>
                  </div>
                  <div class="col-7 total-text">{{ item.curr_sold_unit }} Unit</div>
                </div>
                <!-- As Of Section -->
                <div class="metric-group">
                  <div class="remarks-text">{{ item.tas_remark }}</div>
                  <div class="percentage-value-wrapper">
                    <span class="value-text">{{ item.sold_unit }} Unit</span>
                    <span class="percentage-text" [class]="getPercentageClass(item.as_sales_pctg)">
                      {{ item.as_sales_pctg }}%
                    </span>
                    <span class="value-text">{{ item.total_unit }} Unit</span>
                  </div>
                </div>
                
                
                <!-- Expandable Sections (hanya tampil jika Total di-expand) -->
                <div *ngIf="isTotalExpanded">
                  <!-- mast month Section (selalu tampil) -->
                  <div class="metric-group">
                    <div class="remarks-text">{{ item.lm_remark }}</div>
                    <div class="percentage-value-wrapper">
                      <span class="percentage-text" [class]="getPercentageClass(item.lm_sales_pctg)">
                        {{ item.lm_sales_pctg }}%
                      </span>
                      <span class="value-text">{{ item.lm_sold_unit }} Unit</span>
                    </div>
                  </div>
                  <!-- Last Year Section -->
                  <div class="metric-group">
                    <div class="remarks-text">{{ item.ly_remark }}</div>
                    <div class="percentage-value-wrapper">
                      <span class="percentage-text" [class]="getPercentageClass(item.ly_sales_pctg)">
                        {{ item.ly_sales_pctg }}%
                      </span>
                      <span class="value-text">{{ item.ly_sold_unit }} Unit</span>
                    </div>
                  </div>

                  <!-- This Year Section -->
                  <div class="metric-group">
                    <div class="remarks-text">{{ item.ty_remark }}</div>
                    <div class="percentage-value-wrapper">
                      <span class="value-text">{{ item.ty_sold_unit }} Unit</span>
                      <span class="percentage-text" [class]="getPercentageClass(item.ty_sales_pctg)">
                        {{ item.ty_sales_pctg }}%
                      </span>
                      <span class="value-text">{{ item.total_unit }} Unit</span>
                    </div>
                  </div>

                  
                </div>  
                
              </div>

              <!-- Other Section (dengan icon) -->
              <div class="mb-3 revenue-item-card" *ngFor="let item of residence; let i = index">
                <div *ngIf="item.property_name !== 'Total'" style="padding-top: 20px;">
                  <div class="row header-row" (click)="toggleExpand(i)" style="cursor: pointer;">
                    <div class="col-5 title-text">
                      {{ item.property_name }}
                      <i class="fas ms-2" [class.fa-chevron-down]="!expandedStates[i]" [class.fa-chevron-up]="expandedStates[i]"></i>
                    </div>
                    <div class="col-7 total-text">{{ item.curr_sold_unit }} Unit</div>
                  </div>
                   <div class="metric-group last-group">
                      <div class="remarks-text remarks-with-padding">{{ item.tas_remark }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="value-text">{{ item.sold_unit }} Unit</span>
                        <span class="percentage-text" [class]="getPercentageClass(item.as_sales_pctg)">
                          {{ item.as_sales_pctg }}%
                        </span>
                        <span class="value-text">{{ item.total_unit }} Unit</span>
                      </div>
                    </div>
                  
                  
                  <div *ngIf="expandedStates[i]">
                    <div class="metric-group">
                      <div class="remarks-text remarks-with-padding">{{ item.lm_remark }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(item.lm_sales_pctg)">
                          {{ item.lm_sales_pctg }}%
                        </span>
                        <span class="value-text">{{ item.lm_sold_unit }} Unit</span>
                      </div>
                    </div>
                    <div class="metric-group">
                      <div class="remarks-text remarks-with-padding">{{ item.ly_remark }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="percentage-text" [class]="getPercentageClass(item.ly_sales_pctg)">
                          {{ item.ly_sales_pctg }}%
                        </span>
                        <span class="value-text">{{ item.ly_sold_unit }} Unit</span>
                      </div>
                    </div>
                    <div class="metric-group">
                      <div class="remarks-text remarks-with-padding">{{ item.ty_remark }}</div>
                      <div class="percentage-value-wrapper">
                        <span class="value-text">{{ item.ty_sold_unit }} Unit</span>
                        <span class="percentage-text" [class]="getPercentageClass(item.ty_sales_pctg)">
                          {{ item.ty_sales_pctg }}%
                        </span>
                        <span class="value-text">{{ item.total_unit }} Unit</span>
                      </div>
                    </div>
                   
                  </div>  
                </div>
              </div>

            </div>
            
          </div>
        </div>

        <div class="col-12 col-md-12 col-lg-4">
          <div class="card card-property">
            
            <div class="card-header">
                <h5 class="card-title align-items-center card-title-custom">
                    <img src="assets/icons/pie-chart.png"> Property Availability
                </h5>
            </div>
            
            <div *ngIf="!isLoading && residence.length > 0" style="padding-left:  15px; padding-right: 15px;">
  
              <!-- TOTAL SECTION (Modified) -->
              <div class="container-fluid container-box-progress" *ngFor="let item of totalRevenueOnly">
                
                <!-- Header dengan master toggle -->
                <div class="row header-row">
                  <div class="col-5 title-text">
                    {{ item.property_name }}
                  </div>
                  <div class="percentage-value-wrapper">
                    <span class="value-text">
                      {{ item.available_unit }} Unit
                    </span>
                    <span class="percentage-text">({{ 100 - item.as_sales_pctg }}%)</span>
                  </div>
                </div>

              </div>

              <!-- Other Section (dengan icon) -->
              <div class="mb-3 revenue-item-card" *ngFor="let item of residence; let i = index">
                <div *ngIf="item.property_name !== 'Total'" style="padding-top: 20px;">
                  <div class="row header-row">
                    <div class="col-5 title-text">
                      {{ item.property_name }}
                    </div>
                    <div class="percentage-value-wrapper">
                      <span class="value-text">
                        {{ item.available_unit }} Unit
                      </span>
                      <span class="percentage-text">({{ 100 - item.as_sales_pctg }}%)</span>
                    </div>
                  </div>
                </div>
              </div>

            </div>
            
          </div>
        </div>

      </div>
    </div>

    <div class="container-fluid container-card">
      <div class="row">
        <div class="col-12 col-md-6 col-lg-6">
          <h1 class="heading-1">Residence List</h1>
        </div>
        <div class="col-12 col-md-6 col-lg-6">
          <div class="form-group group-input">
            <input type="text" class="form-control" [(ngModel)]="searchTerm" (keyup)="onSearch($event)"
              placeholder="Type Building Name or Tenant Name">
            <img src="assets/icons/search.png" alt="">
          </div>
        </div>
      </div>

      <div class="table-responsive my-3 p-0 d-none d-lg-block">
        <table class="table table-striped text-nowrap">
          <thead>
            <tr>
              <th class="text-center sortable-header" (click)="onSort('property_name')">
                <span>Name Property</span>
                <i [class]="getSortIcon('property_name')" class="sort-icon"></i>
              </th>
              <!--<th class="text-center sortable-header" (click)="onSort('category_name')">
                <span>Category</span>
                <i [class]="getSortIcon('category_name')" class="sort-icon"></i>
              </th>-->
              <th class="text-center sortable-header" (click)="onSort('total_unit')">
                <span>Total Unit</span>
                <i [class]="getSortIcon('total_unit')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('sold_unit')">
                <span>Sold Unit</span>
                <i [class]="getSortIcon('sold_unit')" class="sort-icon"></i>
              </th>
              <th class="text-center sortable-header" (click)="onSort('available_unit')">
                <span>Available Unit</span>
                <i [class]="getSortIcon('available_unit')" class="sort-icon"></i>
              </th>
              <th class="text-end sortable-header" (click)="onSort('sales_pctg')">
                <span>Sales Percentage</span>
                <i [class]="getSortIcon('sales_pctg')" class="sort-icon"></i>
              </th>
              <th class="text-end sortable-header" (click)="onSort('sales_revenue')">
                <span>Sales Revenue</span>
                <i [class]="getSortIcon('sales_revenue')" class="sort-icon"></i>
              </th>
            </tr>
          </thead>
          <tbody>
            <ng-container *ngIf="!isLoading && residence.length > 0">
              <tr *ngFor="let item of residence">
                <ng-container *ngIf="item.property_name !== 'Total'">
                  <td>
                      <a [routerLink]="['/residences/detail-residences', item.property_id]"
                        routerLinkActive="router-link-active">
                          {{ item.property_name }}
                      </a>
                  </td>
                  <td class="text-center">{{ item.total_unit }}</td>
                  <td class="text-center">{{ item.sold_unit }}</td>
                  <td class="text-center">{{ item.available_unit }}</td>
                  <td class="text-end">{{ item.as_sales_pctg }}%</td>
                  <td class="text-end">{{ item.as_sales_revenue | rupiah }}</td>
                </ng-container>
              </tr>
            </ng-container>
          </tbody>
          <tbody *ngIf="isLoading">
            <tr>
              <td colspan="6" class="text-center">
                <div class="spinner-border text-success" role="status">
                  <span class="visually-hidden">Loading...</span>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="my-4 d-block d-lg-none">

        <div class="card card-sm-custom my-3" [ngClass]="{'border bg-light': i % 2 !== 0}" role="button" tabindex="0"
          *ngFor="let item of residence; let i = index" [routerLink]="['/residences/detail-residences', item.property_id]">
          <ng-container *ngIf="item.property_name !== 'Total'">
            <div class="card-header card-sm-header">
              <h5>{{ item.property_name }}</h5>
            </div>
            <div class="card-body">
              <div class="row">
                <div class="col-5">
                  <div class="card-sm-title">Total Unit</div>
                  <div class="card-sm-title">Sold Unit</div>
                  <div class="card-sm-title">Available Unit</div>
                  <div class="card-sm-title">Sales Percentage</div>
                  <div class="card-sm-title">Sales Revenue</div>
                </div>
                <div class="col-7">
                  <div class="card-sm-title">{{ item.total_unit }}</div>
                  <div class="card-sm-title">{{ item.sold_unit }}</div>
                  <div class="card-sm-title">{{ item.available_unit }}</div>
                  <div class="card-sm-title">{{ item.as_sales_pctg }}%</div>
                  <div class="card-sm-title">{{ item.as_sales_revenue | rupiah }}</div>
                </div>
              </div>
            </div>
          </ng-container>  
          <div class="card-body d-flex justify-content-center" *ngIf="isLoading">
            <div class="spinner-border text-success text-center" role="status">
              <span class="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>

      </div>

      <div class="row">
        <div class="col-12 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-start mb-3">
          <div class="pagination-info">
            Displaying
            <span class="fw-bold">{{ displayRange.start | number }}</span> -
            <span class="fw-bold">{{ displayRange.end | number }}</span>
            out of
            <span class="fw-bold">{{ displayRange.total | number }}</span>
          </div>
        </div>
        <div
          class="col-12 col-md-12 col-lg-6 d-flex justify-content-center justify-content-lg-end justify-content-end page-pagination">
          <nav aria-label="Page navigation">
            <ul class="pagination">
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link first-page" href="javascript:void(0)" (click)="onFirstPage()" aria-label="First">
                  <span aria-hidden="true">&laquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === 1">
                <a class="page-link prev-page" href="javascript:void(0)" (click)="onPrevPage()" aria-label="Previous">
                  <span aria-hidden="true">&lsaquo;</span>
                </a>
              </li>
              <li class="page-item" *ngFor="let page of pageNumbers"
                [class.active]="page === paginationConfig.currentPage">
                <a class="page-link" href="javascript:void(0)" (click)="onPageChange(page)">{{ page }}</a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPages">
                <a class="page-link next-page" href="javascript:void(0)" (click)="onNextPage()" aria-label="Next">
                  <span aria-hidden="true">&rsaquo;</span>
                </a>
              </li>
              <li class="page-item" [class.disabled]="paginationConfig.currentPage === totalPages">
                <a class="page-link last-page" href="javascript:void(0)" (click)="onLastPage()" aria-label="Last">
                  <span aria-hidden="true">&raquo;</span>
                </a>
              </li>
            </ul>
          </nav>
        </div>
      </div>
    </div>

  </div>
</section>